import { FontGroupDTO } from '@/api/dto/FontGroupDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class FontGroupCRUD extends CrudEndpoint<FontGroupDTO> {
  constructor() {
    super('fontgroup');
  }
}
